import { render, staticRenderFns } from "./SelBtn.vue?vue&type=template&id=b9cfcfb0&scoped=true"
import script from "./SelBtn.vue?vue&type=script&lang=js"
export * from "./SelBtn.vue?vue&type=script&lang=js"
import style0 from "./SelBtn.vue?vue&type=style&index=0&id=b9cfcfb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cfcfb0",
  null
  
)

export default component.exports